import { ProjectNotFoundError } from 'errors/TerraError';

export function isProjectNotFoundError(error?: Error): boolean {
  return error instanceof ProjectNotFoundError;
}
